/**
 * 공지사항 내용 보기
 */
import React, { Component } from 'react';
import { Navbar, Row, Col, Button } from 'react-bootstrap';
import { udfAutoLogin, url, udfNoneLoading, udfInlineLoading, openAlert, openConfirm } from '../../common/common'
import $ from 'jquery';
import loader from '../../imgs/ajax-loader.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import SideMenuCmp from './SideMenuCmp';
import { dropByCacheKey } from 'react-router-cache-route';

class NoticeArticleCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      isLoggedIn: null,
      articleInfo: {},
      commentList: [],
      usrInfo: null,
    }
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT') {
        this.props.history.push('/stdt/ruleList');
      } else if (data !== null && data.userSe === 'USR') {
        this.setState({ usrInfo: data });
        this.udfSelectArticle();
      } else {
        this.props.history.push('/');
      }
    });
  }

  udfSelectArticle = () => {
    if (!this.state.usrInfo) return;
    let that = this;
    udfInlineLoading();

    $.ajax({
      url: url + '/cop/bbs/selectBoardArticle.do',
      type: 'GET',
      dataType: 'jsonp',
      data: { isMobile: 'Y', bbsId: that.props.match.params.bbsId, nttId: that.props.match.params.nttId },
      success: function (data) {
        udfNoneLoading();

        if (!data.success)
          that.componentDidMount();
        else {
          if (data.list !== undefined && data.list !== null) {
            that.setState({
              isLoggedIn: true,
              articleInfo: data.list[0],
              commentList: data.commentList
            });
          }
        }
      },
      error: function (jqXHR, status, error) {
        udfNoneLoading();
        that.componentDidMount();
      }
    });
  }

  // 삭제
  udfDelete = () => {
    let that = this;

    openConfirm(this, '삭제하시겠습니까?',
      () => {
        udfInlineLoading();

        $.ajax({
          url: url + '/cop/bbs/deleteBoardArticle.do',
          type: 'GET',
          dataType: 'jsonp',
          data: {
            isMobile: 'Y',
            bbsId: that.props.match.params.bbsId,
            nttId: that.props.match.params.nttId,
          },
          success: function (data) {
            udfNoneLoading();

            if (!data.success)
              that.componentDidMount();
            else {
              if (data.result) {
                dropByCacheKey('qnaCachce');
                that.props.history.go(-1);
              } else
                openAlert(that, '오류가 발생했습니다.');
            }
          },
          error: function (jqXHR, status, error) {
            udfNoneLoading();
            that.componentDidMount();
          }
        });
      });
  }

  render() {
    const commentList = this.state.commentList === undefined ? null :
      this.state.commentList.map((data, idx) => {
        return (
          <Row key={idx}>
            <Col>
              <div style={{ fontSize: '.9rem', color: 'gray' }}>답변: {data.frstRegisterPnttm}</div>
              <pre className="p-2" style={{ whiteSpace: 'pre-wrap' }}>{data.commentCn}</pre>
            </Col>
          </Row>
        );
      });

    return (
      <>
        <div className='wrap-loading'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          {this.props.match.params.bbsId === 'BBSMSTR_000000000001' ? '공지사항' :
            this.props.match.params.bbsId === 'BBSMSTR_000000000021' ? '1:1상담' :
              this.props.match.params.bbsId === 'BBSMSTR_000000000011' ? '업데이트 소식' :
                this.props.match.params.bbsId === 'BBSMSTR_000000000002' ? '학교게시물' : ''}
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        <div className='container-fluid' style={{ marginTop: '4rem' }}>
          <Row className="pb-2 border-bottom">
            <Col>
              {this.state.articleInfo.nttSj}
              <div style={{ fontSize: '.9rem', color: 'gray', marginTop: '.5rem' }}>{this.state.articleInfo.frstRegisterPnttm}</div>
            </Col>
          </Row>
          <Row className="pt-4">
            <Col>
              <p dangerouslySetInnerHTML={{ __html: this.state.articleInfo.nttCn }}></p>
            </Col>
          </Row>
          {
            this.props.match.params.bbsId === 'BBSMSTR_000000000002' && this.state.articleInfo.password !== '' ?
              <Row className="pt-4 text-center">
                <Col>
                  <a type="button" className="btn btn-outline-secondary" href={this.state.articleInfo.password} target="_blank" rel="noopener noreferrer" title="새창">
                    자세히 보기 (상세 페이지로 이동)</a>
                </Col>
              </Row>
              : null
          }
          {this.props.match.params.bbsId === 'BBSMSTR_000000000021' ?
            <Row className="p-4">
              <Button variant='danger' className='col p-2 m-2' onClick={() => { this.udfDelete() }}>삭제</Button>
              <Button variant='secondary' className='col p-2 m-2' onClick={() => { window.location.href = '#/usr/noticeRegist/' + this.props.match.params.bbsId + '/' + this.props.match.params.nttId }}>수정</Button>
            </Row>
            : null}
          <Row className="pt-4">
            <Col>
              {commentList}
            </Col>
          </Row>
        </div>

      </>
    );
  }
}

export default NoticeArticleCmp;